import { createSlice } from "@reduxjs/toolkit";
import socketFactory, { meetingSocketFactory } from "../../../utils/socketFactory";
import PatchClient from "../../../utils/PatchClient";

export const initialState = {
    uiState: {
        is_conference_active: false,
        is_conference_panel_open: false,
        conference_function: false,
        elapsed_time: "00:00:00",
    conference_start_date: null,
        participant: {
            is_participant: false
        },
        master: {
            is_master: false,
            is_principal_master: false
        },
    },
    conference: {
        id: null,
        date: null,
        room_id: null,
        title: null,
        description: null,
        allow_mic: null,
        allow_camera: null,
        allow_screen_share: null,
        allow_audio: null,
        allow_reaction: null,
        allow_messages: null,
        allow_external_participants: null,
        registration_link: null,
        email_confirmation_enabled: false,
        reminder_on_event_day: false,
        reminder_5_min_before: false,
        photo: null,
        actions: [],
        participants: [],
        conversation: null,
    },

}


const activeConferenceSlice = createSlice({
    name: 'activeConference',
    initialState,
    reducers: {
        resetState: (state) => {
            const { uiState, conference } = initialState;

            if (uiState) {
                Object.entries(uiState).forEach(([key, value]) => {
                    if (!['is_conference_panel_open', 'conference_function'].includes(key)) {
                        state.uiState[key] = value;
                    }
                });
            }

            if (conference) {
                Object.entries(conference).forEach(([key, value]) => {
                    state.conference[key] = value;
                });
            }
        },
        setState: (state, action) => {
            const { uiState, conference } = action.payload;

            if (uiState) {
                Object.entries(uiState).forEach(([key, value]) => {
                    if (!['is_conference_panel_open', 'conference_function'].includes(key)) {
                        state.uiState[key] = value;
                    }
                });
            }

            if (conference) {
                Object.entries(conference).forEach(([key, value]) => {
                    state.conference[key] = value;
                });
            }
            if (conference && conference.date) {
                state.uiState.conference_start_date = conference.date;
            }
        },
        setIsConferenceActive: (state, action) => {
            state.uiState.is_conference_active = action.payload
        },
        setIsConferencePanelOpen: (state, action) => {
            state.uiState.is_conference_panel_open = action.payload
        },
        setConferenceId: (state, action) => {
            state.id = action.payload
        },
        setConferenceTitle: (state, action) => {
            state.master_status.title = action.payload
        },
        setConferenceDescription: (state, action) => {
            state.master_status.description = action.payload
        },
        setConferenceBeginDate: (state, action) => {
            state.begin_date = action.payload
        },
        setConferenceRoomId: (state, action) => {
            state.room_id = action.payload
        },
        setConferenceAllowMic: (state, action) => {
            state.conference.allow_mic = action.payload
        },
        setConferenceAllowCamera: (state, action) => {
            state.conference.allow_camera = action.payload
        },
        setConferenceAllowScreenShare: (state, action) => {
            state.conference.allow_screen_share = action.payload
        },
        setConferenceAllowAudio: (state, action) => {
            state.conference.allow_audio = action.payload
        },
        setConferenceAllowReaction: (state, action) => {
            state.conference.allow_reaction = action.payload
        },
        setConferenceAllowMessages: (state, action) => {
            state.conference.allow_messages = action.payload
        },
        setInviteAllInternal: (state, action) => {
            state.conference.invite_all_internal = action.payload
        },
        setAllowExternalParticipants: (state, action) => {
            state.conference.allow_external_participants = action.payload
        },
        setInscriptionLink: (state, action) => {
            state.conference.inscription_link = action.payload
        },
        setConferenceParticipants: (state, action) => {
            state.participants = action.payload
        },
           setConferenceConversations: (state, action) => {
            state.conference.conversation = action.payload;
        },
        setAccessType: (state, action) => {
            state.master_status.access_type = action.payload
        },
        setEmailConfirmationEnabled: (state, action) => {
            state.master_status.email_confirmation_enabled = action.payload
        },
        setReminderOnEventDay: (state, action) => {
            state.master_status.reminder_on_event_day = action.payload
        },
        setReminder5MinBefore: (state, action) => {
            state.master_status.reminder_5_min_before = action.payload
        },
        setConferencePhoto: (state, action) => {
            state.photo = action.payload
        },
        setConferenceActions: (state, action) => {
            state.master_status.actions = action.payload
        },
        setMapId: (state, action) => {
            state.map_id = action.payload
        },
        setConferenceFunction: (state, action) => {
            state.uiState.conference_function = action.payload;
            state.uiState.is_conference_panel_open = true;
        },
        CONFERENCE_START: (state, action) => {
            if (action?.payload?.data?.roomTenantId) console.log('Meeting started in room', action.payload.data.roomTenantId)
        },
        CONFERENCE_UPDATED: (state, action) => {
            console.log('Conference updated:', action.payload)
        }

    }
})

export const {
    resetState,
    setState,
    setIsConferenceActive,
    setIsConferencePanelOpen,
    setConferenceId,
    setConferenceTitle,
    setConferenceDescription,
    setConferenceBeginDate,
    setConferenceRoomId,
    setConferenceAllowMic,
    setConferenceAllowCamera,
    setConferenceAllowScreenShare,
    setConferenceAllowAudio,
    setConferenceAllowReaction,
    setConferenceAllowMessages,
    setInviteAllInternal,
    setAllowExternalParticipants,
    setInscriptionLink,
    setConferenceConversations,
    setConferenceParticipants,
    setAccessType,
    setEmailConfirmationEnabled,
    setReminderOnEventDay,
    setConferenceFunction,
    CONFERENCE_START,
    CONFERENCE_UPDATED
} = activeConferenceSlice.actions

let meetingPatchClient = null;

export const startMeetingsSync = () => (dispatch) => {
    console.log("Starting meetings sync...");

    const reinitMeetingPatchClient = (fullDocument) => {
        meetingPatchClient = null;
        meetingPatchClient = new PatchClient(fullDocument, {
            onPatchRequest: (fromVersion) => {
                meetingSocketFactory.emit('requestMeetingPatch', 'activeConference/requestPatch')({ fromVersion });
            },
            onFullDocumentRequest: () => {
                meetingSocketFactory.emit('requestMeetingFull', 'activeConference/requestFull')();
            },
        });
        console.log('meeting update success', fullDocument)
        dispatch(CONFERENCE_UPDATED(fullDocument.data))
    };

    const requestFullDocument = meetingSocketFactory.emit('requestMeetingFull', 'activeConference/requestFull');

    const onMeetingFull = async (data) => {
        if ((!meetingPatchClient || data.firstRequest) && data) {
            console.log("Reinitializing patch client with fullDocument:", data);
            reinitMeetingPatchClient(data)
        }
        else if (meetingPatchClient && data) {
            console.log("Updating meetings document with fullDocument:", data);
            const patchSuccess = meetingPatchClient.receiveFullDocument(data);
            if (patchSuccess) {
                const updatedMeeting = meetingPatchClient.getDocument();
                console.log("Meetings document updated successfully", updatedMeeting);
                dispatch(CONFERENCE_UPDATED(updatedMeeting.data))
            } else {
                console.warn("Failed to update meetings document with fullDocument");
            }
        }
        else {
            console.warn("No full document provided to updateDocument");
        }
    }


    const onMeetingPatched = (patches) => {
        {
            console.log("Patching Meetings", patches);
            if (meetingPatchClient) {
                const patchSuccess = meetingPatchClient.applyPatches(patches);
                if (patchSuccess) {
                    console.log("Meetings patched successfully");
                    const updatedMeeting = meetingPatchClient.getDocument();
                    console.log("meetings patched", updatedMeeting)
                    dispatch(CONFERENCE_UPDATED(updatedMeeting.data))
                } else {
                    console.warn("Failed to apply meetings patch");
                }
            } else {
                console.warn("MeetingsPatchClient is not initialized, cannot apply patch");

            }
        }
    }

    const sessionHandles = [
        meetingSocketFactory.on('meetingPatched', (payload) => onMeetingPatched(payload.data)),
        meetingSocketFactory.on('meetingFull', (payload) => onMeetingFull(payload.data)),
        meetingSocketFactory.on('meeting_ended', resetState),
        meetingSocketFactory.on('disconnect', resetState),
    ];

    let cleaned = false;
    // Defined before termination handles so it can be passed directly
    const cleanup = async () => {
        if (cleaned) return;
        cleaned = true;
        // No awaiting terminationHandles — they're already resolving as we speak
        const resolved = await Promise.all(sessionHandles);
        resolved.forEach(handle => meetingSocketFactory.off(handle));
        terminationHandles.then(resolved => resolved.forEach(handle => meetingSocketFactory.off(handle)));
        dispatch(resetState());
    };

    const terminationHandles = Promise.all([
        meetingSocketFactory.on('meeting_ended', cleanup),
        meetingSocketFactory.on('disconnect', cleanup),
    ]);

    dispatch(requestFullDocument());
};

export const USER_TYPING = meetingSocketFactory.emit('userTyping', 'activeConference/USER_TYPING')

socketFactory.on("meeting_started", CONFERENCE_START)

export default activeConferenceSlice.reducer